/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from 'formik';
import { Button, CircularProgress, Select, FormControl, FormControlLabel, Grid, InputLabel, Switch, FormHelperText, MenuItem } from '@mui/material';
import { useEffect } from 'react';
import { getAllAuthProvider } from '../../../../../../../store/reducers/authProvider/authProviderActions';
import { getAllOrg } from '../../../../../../../store/reducers/organization/organizationAction';

const OrgAuthProviderForm = ({  errors, touched,
    values, handleBlur, handleChange, setFieldValue, handleClose, isSubmitting }) => {
    const authProviders = useSelector(state => state.authProvider.authProviders);
    const organizations = useSelector(state => state.organization.organizations)
    const dispatch = useDispatch()
    useEffect(() => {
         dispatch(getAllAuthProvider());
         dispatch(getAllOrg())
    }, [ dispatch]);

    return (


        <Form>

            <Grid container spacing={4}>
                {values.hasOwnProperty("authProviderID") && <Grid item xs={12} md={12} sm={12}>


                    <FormControl fullWidth error={Boolean(touched.authProviderID && errors.authProviderID)}>
                        <InputLabel htmlFor="outlined-status">Identity Provider</InputLabel>
                        <Select
                            value={values.authProviderID}
                            variant="outlined"
                            name="authProviderID"
                            label="Identity Provider"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            style={{ color: 'white' }}
                        >
                            {authProviders?.length > 0 && authProviders?.map((item) => (
                                <MenuItem value={item.authProviderID}>
                                    {item.authProviderName}
                                </MenuItem>
                            ))}


                        </Select>
                        <FormHelperText style={{ color: "red" }} >{errors.organizationID}</FormHelperText>

                    </FormControl>
                </Grid>
                }
                {values.hasOwnProperty("organizationID") && <Grid item xs={12} md={12} sm={12}>


                    <FormControl fullWidth error={Boolean(touched.organizationID && errors.organizationID)}>
                        <InputLabel htmlFor="outlined-status">Organization</InputLabel>
                        <Select
                            value={values.organizationID}
                            variant="outlined"
                            name="organizationID"
                            label="ORganization"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            style={{ color: 'white' }}
                        >
                            {organizations?.Records?.length > 0 && organizations?.Records?.map((item) => (
                                <MenuItem value={item.organizationID}>
                                    {item.organizationName}
                                </MenuItem>
                            ))}


                        </Select>
                        <FormHelperText style={{ color: "red" }} >{errors.organizationID}</FormHelperText>

                    </FormControl>
                </Grid>
                }
                {values.detailValue && <Grid item xs={12} md={6} sm={6}>
                    <FormControlLabel
                        control={<Switch />}
                        name="details"
                        checked={values.detailValue === "true"}
                        onChange={(event, checked) => {
                            setFieldValue("detailValue", checked ? "true" : "false");
                        }}
                        label={values.detailValue === "true" ? 'Authorized' : 'Unauthorized'}
                    />
                </Grid>}
                <Grid item xs={12} md={12} sm={12}>
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit" style={{ marginTop: '20px' }}
                        disabled={isSubmitting}>
                        {isSubmitting &&
                            <CircularProgress size={24} color='success' style={{ marginLeft: '10px' }} />} Save
                    </Button>
                    <Button variant="outlined" onClick={() => handleClose()} style={{ marginTop: '20px', marginLeft: '10px' }}>close</Button>

                </Grid>

            </Grid>
        </Form>

    )

}

 
export default OrgAuthProviderForm;
